<template>
  <div>
    <router-view />
    <notifications position="top center" width="100%"/>
    <ag-logout-modal :opened="isModalCreated"></ag-logout-modal>
  </div>
</template>
<script>
import { useStore } from "@/store";
import AgLogoutModal from "@/components/ag-logout-modal/index.vue";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
const store = useStore();
export default {
  components: { AgLogoutModal },
  name: "App",
  computed: {
    isModalCreated() {
      return store.state.general.isModalCreate;
    },
  },
  methods: {
    /*eslint-disable*/
    idleLogout() {
      const jQuery = window.jQuery;
      var t;
      window.onload = resetTimer;
      window.onmousemove = resetTimer;
      window.onmousedown = resetTimer;
      window.ontouchstart = resetTimer;
      window.ontouchmove = resetTimer;
      window.onclick = resetTimer;
      window.onkeydown = resetTimer;
      window.addEventListener("scroll", resetTimer, true);
      function setIdle() {
        store.commit(GeneralActionTypes.SET_ISCREATED_MODAL, true);
        jQuery("#logoutModal").modal("toggle");
      }
      function resetTimer() {
        clearTimeout(t);
        if (this.isModalCreated) {
          store.commit(GeneralActionTypes.SET_ISCREATED_MODAL, false);
        }
        t = setTimeout(setIdle, 1000 * 60 * 30);
      }
    },
  },
  created() {
    if (typeof window !== 'undefined') {
      window.store = store;
    }
    this.idleLogout();
    const jQuery = window.jQuery;
    jQuery(document).mouseup(function (e) {
      var container = jQuery(".ag__dropdown");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('active');
      }
    });
  },
};
</script>

<style lang="scss">
@import "src/assets/styles/styles";
</style>
